import React, { useEffect } from "react";
import Button from "../../components/common/button";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { fetchTotalsTicketsAndWinByUserId } from "../../redux/slices/totalTicketsAndWinSlice";
import { getJackpotNumberData } from "../../redux/slices/winnersSlice";
import BackdropSpinner from "../../components/backdropSpinner";

function LotteryAccountDetails() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { jackpotNumber, loading } = useSelector((state) => state.winners);
  const lotteryNumber = jackpotNumber?.number;

  const formattedDate = jackpotNumber?.drawDate
    ? new Intl.DateTimeFormat("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      }).format(new Date(jackpotNumber.drawDate))
    : "";

  // Fetch the jackpot number when the component mounts
  useEffect(() => {
    dispatch(getJackpotNumberData());
  }, [dispatch]);

  const userId = localStorage.getItem("userID");

  // Navigate to the payment transactions page
  const handleNavigate = () => {
    navigate("/payment-transactions");
  };

  // Retrieves user's total tickets and winnings from Redux store.
  const { totalTicketsAndWin } = useSelector(
    (state) => state.userTicketsAndWins
  );

  // Fetch user's total tickets and winnings if userId is available
  useEffect(() => {
    if (userId) {
      dispatch(fetchTotalsTicketsAndWinByUserId(userId));
    }
  }, [dispatch, userId]);

  // Fetch jackpot number data (redundant call - consider removing or refactoring)
  useEffect(() => {
    dispatch(getJackpotNumberData());
  }, [dispatch]);

  // Display a loading spinner while data is being fetched
  if (loading) {
    return <BackdropSpinner />;
  }

  return (
    <>
      {/* Title */}
      <div className="flex justify-center my-3 flex-row gap-5">
        <p className="text-white text-lg sm:text-xl md:text-2xl font-medium text-center">
          {t("lotteryAccountDetails.headerTitle")}
        </p>
      </div>

      {/* Account Overview */}
      <div className="flex pl-[10%] lg:justify-center px-4 lg:px-12">
        <p className="text-white text-lg sm:text-xl font-[Tiro Devanagari Hindi] leading-[24px]">
          {t("lotteryAccountDetails.accountOverview")}
        </p>
      </div>

      {/* Cards section */}
      <div className="flex items-center justify-center lg:justify-center gap-4 lg:gap-8 m-4  ">
        {/* Card 1 */}
        <div className="w-[157px] sm:w-[164px] h-[100px] relative rounded-lg overflow-hidden border border-[#D8AA5F]">
          <div className="absolute left-3 top-3 text-[#FFBF4D] text-md sm:text-sm font-[Tiro Devanagari Hindi] leading-5">
            {t("lotteryAccountDetails.totalWins")}
          </div>
          <div className="absolute left-3 top-[50px] text-white text-xl sm:text-xl font-[Roboto] font-medium">
            {totalTicketsAndWin?.stats?.total_winning}
          </div>
          {/* <div className="absolute left-3 top-[68px] text-white text-xs sm:text-sm font-[Roboto]">
            +50
          </div> */}
        </div>

        {/* Card 2 */}
        <div className="w-[157px] sm:w-[164px] h-[100px] relative rounded-lg overflow-hidden border border-[#D8AA5F]">
          <div className="absolute left-3 top-3 text-[#FFBF4D] text-md sm:text-sm font-[Tiro Devanagari Hindi] leading-5 ">
            {t("lotteryAccountDetails.totalTicketsPurchased")}
          </div>
          <div className="absolute left-3 top-[50px] text-white text-xl sm:text-xl font-[Roboto] font-medium">
            {totalTicketsAndWin?.stats?.total_tickets}
          </div>
          {/* <div className="absolute left-3 top-[68px] text-white text-xs sm:text-sm font-[Roboto]">
            +50
          </div> */}
        </div>
      </div>

      {/* Recent Lottery Section */}
      <div className="text-[#FFBF4D] text-lg sm:text-xl font-[Tiro Devanagari Hindi] leading-[24px] px-10 mt-10  lg:text-center">
        {t("lotteryAccountDetails.recentLotteryNumber")}
      </div>

      <div className="flex items-center justify-start lg:justify-center  ">
        <div className="w-[120px] sm:w-[120px] h-[30px] py-[2px] mx-10 my-5  px-[5px] bg-gradient-to-r from-[#C38B20] to-[#E5AA36] rounded-full flex items-center ">
          <div className="text-black text-[13px] font-bold sm:text-[12px] font-[Tiro Devanagari Hindi] font-normal pl-2 lg:pl-2">
            {t("lotteryAccountDetails.winningNumber")}
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center m-8">
        <img
          src="/images/bubble.png"
          alt="lottery-no"
          className="rounded-lg shadow-lg w-20 h-20"
        />
        <span className="absolute text-center text-black font-bold text-[40px]">
          {lotteryNumber}
        </span>
      </div>

      <div className="flex items-center justify-center">
        <div className="relative w-80 h-24 rounded-lg overflow-hidden border border-[#D8AA5F] p-5 flex justify-center items-center">
          {/* Badge */}
          <div className="absolute left-3 top-3 text-[#FFBF4D] text-lg font-bold font-roboto leading-5 break-words md:text-base">
            #{lotteryNumber}
          </div>
          {/* Date */}
          <div className="absolute left-3 top-9 text-white text-sm leading-6 font-[Tiro_Devanagari_Hindi] break-words">
            {formattedDate} {t("lotteryAccountDetails.drawDate")}
          </div>
          {/* Points */}
          {/* <div className="absolute left-3 bottom-3 text-white text-xs font-light font-roboto leading-5 break-words">
            +50
          </div> */}
          {/* Image */}
          {/* <img
      className="absolute w-14 h-16 left-24 top-8"
      src="https://via.placeholder.com/56x65"
      alt="Placeholder"
    /> */}
        </div>
      </div>

      <div className="flex items-center justify-center my-5">
        <Button
          text={t("lotteryAccountDetails.downloadAccountStatement")}
          onClick={handleNavigate}
        />
      </div>
    </>
  );
}

export default LotteryAccountDetails;
